import { CheckedIcon } from 'assets/icons';
import Spinner from 'Components/Spinner';
import { default as Tooltip, default as ToolTip } from 'Components/Tooltips';
import { ReactNode } from 'react';

interface IPill {
  children?: ReactNode | string;
  tooltip?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement> | undefined;
  className?: string;
  nameClassName?: string;
  overlayClassName?: string;
  badgeClassName?: string;
  showBadge?: boolean;
}
export function Loading({ children, onClick, className }: IPill) {
  return (
    <Pill
      className={className}
      children={children}
      nameClassName="animate-pulse bg-green-light"
      badgeClassName={'bg-white text-white'}
      onClick={onClick}
      badge={<Spinner bounce={false} />}
    />
  );
}

export function Delete({
  children,
  onClick,
  className,
  nameClassName,
  showBadge = true,
}: IPill) {
  return (
    <Pill
      children={children}
      className={` ${
        showBadge && 'hover:bg-red-200 cursor-pointer hover:text-white  '
      } text-xs text-gray-dark bg-gray-dark bg-opacity-10  ${className}`}
      onClick={onClick}
      overlayClassName={''}
      nameClassName={nameClassName}
      badgeClassName={'border-black border text-white self-start bg-black'}
      badge={
        <div className="text-xs flex items-center justify-center p-1">x</div>
      }
      showBadge={showBadge}
    />
  );
}

export function Success({ children, onClick }: IPill) {
  return (
    <Pill
      children={children}
      onClick={onClick}
      nameClassName="bg-green-light"
      badgeClassName={'text-white'}
      badge={<CheckedIcon />}
    />
  );
}

export function Error({ children, onClick, tooltip }: IPill) {
  return (
    <ToolTip message={tooltip}>
      <Pill
        children={children}
        className="hover:animate-shake bg-red-200 text-white cursor-pointer"
        onClick={onClick}
        badgeClassName={'border-black border text-white self-start bg-black'}
        badge={<>!</>}
      />
    </ToolTip>
  );
}

export function Pill({
  badge = <></>,
  className = '',
  overlayClassName = '',
  badgeClassName = '',
  nameClassName = '',
  onClick,
  tooltip,
  children,
  showBadge = true,
}: {
  badge?: React.ReactNode;
  className?: string;
  nameClassName?: string;
  badgeClassName?: string;
  overlayClassName?: string;
  children?: ReactNode;
  showBadge?: boolean;
} & IPill) {
  return (
    <>
      <Tooltip message={tooltip}>
        <div
          onClick={onClick}
          className={`relative rounded-lg flex justify-center items-center shadow text-gray-dark ${className} ${
            onClick ? 'cursor-pointer' : ''
          }`}
        >
          <div className={`w-full h-full px-2 py-1.5 ${nameClassName}`}>
            {children}
          </div>
          <div
            className={`w-full h-full absolute hover:flex justify-end ${overlayClassName}`}
          >
            {showBadge && (
              <div
                className={`absolute -right-1 -top-1 self-start h-4 w-4 rounded-full flex items-center justify-center font-semibold ${badgeClassName}`}
              >
                {badge}
              </div>
            )}
          </div>
        </div>
      </Tooltip>
    </>
  );
}

export default {
  Default: Pill,
  Success,
  Error,
  Loading,
  Delete,
};
